import dayjs from 'dayjs'
import dayOfYear from 'dayjs/plugin/dayOfYear'

dayjs.extend(dayOfYear)

/**
 * Convert Day of Year to dayjs Date object (current year)
 * @param {number} doy - Day of Year (1-365)
 * @returns {dayjs.Dayjs} - dayjs Date object
 */
export const dayOfYearToDate = (doy) => {
  return dayjs().dayOfYear(doy)
}

/**
 * Convert Date to Day of Year
 * @param {dayjs.Dayjs|Date|string} date - Date object
 * @returns {number} - Day of Year (1-365)
 */
export const dateToDayOfYear = (date) => {
  return dayjs(date).dayOfYear()
}

/**
 * Format DOY as readable date string
 * @param {number} doy - Day of Year (1-365)
 * @returns {string} - Formatted date (e.g., "May 15")
 */
export const formatDOYAsDate = (doy) => {
  return dayOfYearToDate(doy).format('MMM D')
}

/**
 * Validate frost date range (FFD must be after LFD)
 * @param {number} lfd - Last Frost Date DOY
 * @param {number} ffd - First Frost Date DOY
 * @returns {boolean} - True if valid range
 */
export const isValidFrostDateRange = (lfd, ffd) => {
  return ffd > lfd
}

/**
 * Convert Day of Year (DOY) to native JavaScript Date object for the current year.
 * @param {number} doy - Day of Year (1-365 or 366)
 * @returns {Date} - JavaScript Date object
 */
export function doyToJSDate(doy) {
  const year = dayjs().year();
  // Set date to January 1 and add (doy - 1) days
  return new Date(year, 0, doy);
}
